/*
  quantity.js
  - snippets/product-form.liquid 内の数量ボックス (.pos-qty-box) を
    いつでも「Add to Cart」ボタン直前に配置する
  - テーマエディタ(Shopify.designMode)での設定ON/OFFやDOM差し替えにも即対応
*/

(() => {
  const QTY_SEL = '.pos-qty-box';
  const ADD_BTN_SEL = '#AddToCart-, [type="submit"][name="add"], .product-form__submit, button[name="add"]';

  /** 単一フォームで数量ボックスをボタン直前へ */
  function placeInForm(form) {
    if (!form) return;
    const qty = form.querySelector(QTY_SEL);
    if (!qty) return; // show_quantity=false なら何も出ない

    // 可能ならIDで優先（#AddToCart-<section_id>）
    let addBtn = form.querySelector('[id^="AddToCart-"]');
    if (!addBtn) {
      // フォールバック: name="add" など
      addBtn =
        form.querySelector('[type="submit"][name="add"]') ||
        form.querySelector('.product-form__submit') ||
        form.querySelector('button[name="add"]');
    }
    if (!addBtn) return;

    if (qty.nextElementSibling !== addBtn) {
      addBtn.parentNode.insertBefore(qty, addBtn);
    }
  }

  /** ページ上のすべての AddToCart フォームに適用 */
  function placeAll() {
    document
      .querySelectorAll('form.product-single__form, product-form form, form[action*="/cart/add"]')
      .forEach(placeInForm);
  }

  /** フォーム内の順番変化を監視して常に直前へ戻す */
  function observeForms() {
    document
      .querySelectorAll('form.product-single__form, product-form form, form[action*="/cart/add"]')
      .forEach((form) => {
        const mo = new MutationObserver(() => placeInForm(form));
        mo.observe(form, { childList: true, subtree: true });
      });
  }

  /** まとめて再初期化 */
  function reinit() {
    // 1フレーム待ってから（差し替え直後のDOM安定待ち）
    requestAnimationFrame(() => {
      placeAll();
      observeForms();
    });
  }

  /** 通常ストア表示 */
  function initNormal() {
    placeAll();
    observeForms();
  }

  /** テーマエディタ表示（デザインモード） */
  function initDesignMode() {
    reinit();

    // セクション/ブロックのロード・選択・並び替え で再適用
    document.addEventListener('shopify:section:load', reinit);
    document.addEventListener('shopify:section:select', reinit);
    document.addEventListener('shopify:section:deselect', reinit);
    document.addEventListener('shopify:section:reorder', reinit);
    document.addEventListener('shopify:block:select', reinit);

    // 設定トグルやアプリ注入など、DOMの差し替え全般にも対応
    const bodyMO = new MutationObserver(() => reinit());
    bodyMO.observe(document.body, { childList: true, subtree: true });
  }

  // エントリーポイント
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.Shopify && Shopify.designMode) initDesignMode();
      else initNormal();
    });
  } else {
    if (window.Shopify && Shopify.designMode) initDesignMode();
    else initNormal();
  }
})();